namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_table2, {

		Query_status: {
			'[broken]': { true: { color: $shm_theme.error } },
		},

		Cell_atom_link: {
			padding: 0,
			maxWidth: '600px',
		},

		Cell_list_link: {
			padding: 0,
			maxWidth: '600px',
		},

		Cell_select: {
			padding: 0,
			maxWidth: '600px',
		},

		Select_value: { width: '100%' },

		Atom_link_content: {
			width: '100%',
			maxHeight: '600px',
			overflow: 'auto',
			flexWrap: 'wrap',
		},

		Atom_link_pick: {
			marginLeft: 'auto',
			Trigger: {
				padding: $mol_gap.text,
				justify: { content: 'center' },
			},
			Option_row: {
				padding: $mol_gap.text,
			},
		},

		List_link_content: {
			width: '100%',
			maxHeight: '600px',
			overflow: 'auto',
			flexWrap: 'wrap',
			minWidth: 0,
		},

		Atom_link_item: {
			'[selected]': { true: { color: $mol_theme.current } },
		},

		List_link_item: {
			whiteSpace: 'nowrap',
			'[selected]': { true: { color: $mol_theme.current } },
		},
		List_link_more: {
			flex: { shrink: 0 },
		},
		List_link_create: { '[selected]': { true: { color: $mol_theme.current } } },

		Relation_edit_panel: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			maxWidth: '42vw',
			minWidth: '20rem',
			minHeight: 0,
			overflow: 'hidden',
			padding: 0,
			background: { color: $mol_theme.back },
			border: { left: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Relation_edit_form: {
			width: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
		},

	} )

}
